<script setup lang="ts">
import { Image as VanImage } from 'vant'

defineOptions({ name: 'RemoteImage' })

withDefaults(defineProps<{
  src?: string | null
  alt?: string
  /** spinner 尺寸，默认 20 */
  loadingSize?: number | string
  /** 对应 CSS object-fit，直接传给 van-image */
  fit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
}>(), {
  fit: 'contain',
})
</script>

<template>
  <van-image v-if="src" :src="src" :alt="alt" decoding="async" :fit="fit" v-bind="$attrs" class="remote-image">
    <template #loading>
      <van-loading type="spinner" :size="loadingSize ?? 20" />
    </template>
  </van-image>
</template>

<style scoped>
.remote-image :deep(.van-image__loading) {
  background-color: transparent;
}
.remote-image :deep(.van-image__error) {
  background-color: transparent;
}
</style>
